<template>
    <el-dialog :title="'表名：'+tableName" v-if="dialogFormVisible" :visible.sync="dialogFormVisible" width="80%" top="5vh">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="结构说明" name="first">
                <config v-if="activeName == 'first'" :tableName="tableName"></config>
            </el-tab-pane>
            <el-tab-pane label="数据详情" name="second">
                <info-data v-if="activeName == 'second'" :tableName="tableName"></info-data>
            </el-tab-pane>
        </el-tabs>
    </el-dialog>
</template>

<script>
import Config from './config'
import InfoData from './infoData'
export default {
    props: {
        tableName: {
            type: String,
            default: ''
        }
    },

    components: {Config,InfoData},

    data() {
        return {
            dialogFormVisible:false,
            activeName: 'first'
        }
    },

    methods: {
        // 初始化数据
        init() {
            this.dialogFormVisible = true,
            this.activeName = 'first'
        },

        // 切换tab选项卡
        handleClick(val) {
            console.log(val)

            console.log(this.activeName)
        }
    }
}
</script>